module.exports = __webpack_public_path__ + "img/jt.dcf762a3.png";